module.exports = __webpack_public_path__ + "media/images/badge/cervellone-b30b2bd450bd0d9662749d74e2aec73b.png";